export default {
  namespaced: true,
  state: {
    categories: {},
    loading: false,
    error: null,
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },
  actions: {
    async loadCategories({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const baseUrl = process.env.VUE_APP_COS_BASE_URL || ''
        const url = `${baseUrl}/categories.json`
        const resp = await fetch(url)
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        const categories = await resp.json()
        commit('SET_CATEGORIES', categories)
        commit('SET_LOADING', false)
        return categories
      } catch (error) {
        console.error('Error loading categories:', error)
        commit('SET_ERROR', error.message)
        commit('SET_LOADING', false)

        // Fallback to default categories structure
        const defaultCategories = {
          news: {
            name: 'News',
            slug: 'news',
            path: '/news/',
            metaTitle: 'Latest Gaming News | GamesNest',
            metaDescription: 'Breaking gaming news, release dates, rumors and industry updates.',
            subcategories: [
              { slug: 'latest-news', name: 'Latest News', path: '/news/latest-news/' },
              { slug: 'trending', name: 'Trending', path: '/news/trending/' },
              { slug: 'release-dates', name: 'Release Dates', path: '/news/release-dates/' },
              { slug: 'industry-news', name: 'Industry News', path: '/news/industry-news/' },
              { slug: 'rumors', name: 'Rumors', path: '/news/rumors/' },
            ],
          },
          reviews: {
            name: 'Reviews',
            slug: 'reviews',
            path: '/reviews/',
            metaTitle: 'Game Reviews | GamesNest',
            metaDescription: 'In-depth game reviews, hardware reviews, and DLC reviews.',
            subcategories: [
              { slug: 'game-reviews', name: 'Game Reviews', path: '/reviews/game-reviews/' },
              { slug: 'hardware-reviews', name: 'Hardware Reviews', path: '/reviews/hardware-reviews/' },
              { slug: 'dlc-reviews', name: 'DLC Reviews', path: '/reviews/dlc-reviews/' },
              { slug: 'indie-reviews', name: 'Indie Reviews', path: '/reviews/indie-reviews/' },
            ],
          },
          guides: {
            name: 'Guides',
            slug: 'guides',
            path: '/guides/',
            metaTitle: 'Gaming Guides & Tips | GamesNest',
            metaDescription: 'Walkthroughs, tips, tricks, and guides for your favorite games.',
            subcategories: [
              { slug: 'walkthroughs', name: 'Walkthroughs', path: '/guides/walkthroughs/' },
              { slug: 'tips-tricks', name: 'Tips & Tricks', path: '/guides/tips-tricks/' },
              { slug: 'builds', name: 'Builds', path: '/guides/builds/' },
              { slug: 'beginners-guides', name: 'Beginners Guides', path: '/guides/beginners-guides/' },
              { slug: 'advanced-guides', name: 'Advanced Guides', path: '/guides/advanced-guides/' },
            ],
          },
          deals: {
            name: 'Deals',
            slug: 'deals',
            path: '/deals/',
            metaTitle: 'Gaming Deals & Offers | GamesNest',
            metaDescription: 'Best gaming deals, hardware discounts, and subscription offers.',
            subcategories: [
              { slug: 'game-deals', name: 'Game Deals', path: '/deals/game-deals/' },
              { slug: 'hardware-deals', name: 'Hardware Deals', path: '/deals/hardware-deals/' },
              { slug: 'subscription-deals', name: 'Subscription Deals', path: '/deals/subscription-deals/' },
              { slug: 'bundle-deals', name: 'Bundle Deals', path: '/deals/bundle-deals/' },
            ],
          },
        }
        commit('SET_CATEGORIES', defaultCategories)
        return defaultCategories
      }
    },
  },
  getters: {
    getCategoryBySlug: (state) => (slug) => {
      return state.categories[slug] || null
    },
    getSubcategory: (state) => (categorySlug, subcategorySlug) => {
      const category = state.categories[categorySlug]
      if (!category || !category.subcategories) return null
      return category.subcategories.find(sub => sub.slug === subcategorySlug) || null
    },
    getAllCategories: (state) => {
      return Object.values(state.categories)
    },
    getSubcategoriesByCategory: (state) => (categorySlug) => {
      const category = state.categories[categorySlug]
      return category && category.subcategories ? category.subcategories : []
    },
  },
}
